/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle, NavItem, NavLink, InputGroup,
  TabContent, TabPane, Nav, Collapse, Button, CardHeader,
} from 'reactstrap';
import classnames from 'classnames';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import toastr from 'toastr';
import moment from 'moment';
import 'toastr/build/toastr.min.css';
import BaseGrid from '../../components/Common/BaseGrid';
import KitFormModal from '../../components/Inventory/KitFormModal';

import InventoryForm from '../../components/Inventory/InventoryForm';
import { get, post } from '../../helpers/api_helper';

function ViewItem(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const history = useHistory();

  const { t } = props;
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [isGallery, setIsGallery] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [editCollapse, setEditCollapse] = useState(false);
  const [increment, setIncrement] = useState(-0);
  const [signal, setSignal] = useState(0);
  const [kitModal, setKitModal] = useState(false);

  const copyToClipboard = async (value) => {
    if (!value) {
      return;
    }

    try {
      await navigator.clipboard.writeText(String(value));
      toastr.success(t('Copied to clipboard'), t('Success'));
    } catch (err) {
      toastr.error(t('Unable to copy'), t('Error'));
    }
  };

  const renderCopyableValue = (value) => {
    if (!value) {
      return '-';
    }

    return (
      <span className="d-inline-flex align-items-center gap-2">
        <span>{value}</span>
        <small>
          <button
            type="button"
            className="btn btn-link btn-sm p-0 border-0 text-muted align-baseline"
            title={t('Copy')}
            aria-label={t('Copy')}
            onClick={() => copyToClipboard(value)}
          >
            <i className="mdi mdi-content-copy font-size-14" aria-hidden="true" />
          </button>
        </small>
      </span>
    );
  };

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let item;

        if (window.location.pathname.includes('stock')) {
          item = await get(`/api/inventory/getByStockId/${id}`);

          if (item === '') {
            const kit = await get(`/api/inventory/kit/stock/${id}`);

            if (kit !== null) {
              history.push(`/kits/${kit.id}`);
            }
          }
        } else {
          item = await get(`/api/inventory/get/${id}`);
        }

        setData(item);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, [refresh]);

  const onSuccess = () => {
    setRefresh(refresh + 1);
    setEditCollapse(false);
  };

  const incrementQty = async (e) => {
    e.preventDefault();

    try {
      await post(`/api/inventory/increment/${id}?inc=${increment}`);
      setRefresh(refresh + 1);
      setIncrement(-0);
      toastr.success(t('Quantity updated'));
    } catch (err) {
      toastr.error(err.message);
    }
  };

  const deleteKit = async (row) => {
    if (window.confirm(props.t('Are you sure you want to delete this kit?'))) {
      await post('/api/inventory/kit/delete', { id: row.id });
      setSignal(signal + 1);
    }
  };

  const editKit = (row) => {
    setKitModal(row);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col lg="12">
            <Collapse isOpen={editCollapse}>
              <Row>
                <Col xxl="8">
                  <Card>
                    <CardBody>
                      <CardTitle className="h4">{t('Edit Item')}</CardTitle>
                      {data !== null && (
                        <InventoryForm actionUrl="/api/inventory/save" entity={data} onSuccess={onSuccess} />
                      )}
                      <Button
                        type="submit"
                        color="secondary"
                        form="ItemEditForm"
                        className="float-end"
                      >
                        {t('Save Changes')}
                      </Button>
                      <Button
                        type="button"
                        color="dark"
                        onClick={() => { setEditCollapse(false); }}
                        className="float-end me-3 btn-soft-dark"
                      >
                        {t('Cancel')}
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Collapse>

            <Collapse isOpen={!editCollapse}>
              <Row>
                <Col md="5">
                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Details')}</CardHeader>
                    <CardBody>
                      <table className="table table-bordered table-striped mt-3 table-sm">
                        <tbody>
                          <tr>
                            <th>{t('Stock ID')}</th>
                            <td>{loading === true ? t('Loading...') : renderCopyableValue(data.stock_id)}</td>
                          </tr>
                          <tr>
                            <th>{t('SJ Ref')}</th>
                            <td>{loading === true ? t('Loading...') : renderCopyableValue(data.sj_sku)}</td>
                          </tr>
                          <tr>
                            <th>{t('Manufacturer')}</th>
                            <td>{loading === true ? t('Loading...') : data.manufacturer}</td>
                          </tr>
                          <tr>
                            <th>{t('Part Number')}</th>
                            <td>{loading === true ? t('Loading...') : renderCopyableValue(data.part_number)}</td>
                          </tr>
                          <tr>
                            <th>{t('Box Size')}</th>
                            <td>{loading === true ? t('Loading...') : (data.box?.box_name || '-')}</td>
                          </tr>
                          <tr>
                            <th>{t('Available Qty')}</th>
                            <td>{loading === true ? t('Loading...') : data.qty}</td>
                          </tr>
                          <tr>
                            <th>{t('Shelf Qty')}</th>
                            <td>{loading === true ? t('Loading...') : data.stock.reduce((a, c) => a + c.qty, 0)}</td>
                          </tr>
                          <tr>
                            <th>{t('Has Core')}</th>
                            {/* eslint-disable-next-line no-nested-ternary */}
                            <td>{loading === true ? t('Loading...') : (data?.has_core ? t('Yes') : t('No'))}</td>
                          </tr>
                        </tbody>
                      </table>

                      <Button color="warning" title={t('Edit Item')} className="btn-soft-warning text-dark" onClick={() => { setEditCollapse(true); }}>
                        <span className="mdi mdi-pencil" />
                      </Button>
                    </CardBody>
                  </Card>

                  {process.env.REACT_APP_STATIC_INVENTORY === '1' && (
                    <Card>
                      <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Quantity')}</CardHeader>
                      <CardBody>
                        <form method="post" action={`/api/inventory/increment/${id}`} onSubmit={incrementQty}>
                          <InputGroup>
                            <input type="number" className="form-control" step="1" name="inc" onChange={(e) => { setIncrement(e.target.value); }} value={increment} />
                            <Button type="submit" color="primary" className="btn-soft-primary">
                              {t('Increment')}
                            </Button>
                          </InputGroup>

                          <p className="pt-2 mb-2">{t('Modify the qty up or down by this number.')}</p>
                          <span className="text-danger">
                            {t('Projected qty')}
                            {': '}
                            {loading === true ? t('Loading...') : data.qty + parseInt(increment, 10)}
                          </span>
                        </form>
                      </CardBody>
                    </Card>
                  )}

                  {process.env.REACT_APP_STATIC_INVENTORY !== '1' && (
                    <Card className="mt-3">
                      <CardHeader className="text-uppercase bg-transparent border-bottom">{t('History')}</CardHeader>
                      <CardBody>
                        {data !== null && (
                          <BaseGrid
                            url="/api/warehouse/location/logs"
                            filters={`pll.stock_id=${data.stock_id}`}
                            hasSearch
                            className="table table-striped table-bordered table-sm fs-5"
                            config={
                              {
                                columns: {
                                  physical_location_label: {
                                    label: 'Location',
                                    sort: true,
                                    class: 'fs-6',
                                  },
                                  user: {
                                    label: 'User',
                                    sort: true,
                                    class: 'fs-6',
                                  },
                                  action: {
                                    label: 'Action',
                                    class: 'fs-6',
                                  },
                                  qty: {
                                    label: 'Qty',
                                    class: 'fs-6',
                                  },
                                  created_at: {
                                    label: 'Date',
                                    date: {
                                      format: (date) => (moment(date).fromNow()),
                                      timezone: process.env.REACT_APP_LOCAL_TZ,
                                    },
                                    class: 'fs-6',
                                  },
                                },
                                pagination: {
                                  sort: 'id',
                                  direction: 'DESC',
                                  perPage: 6,
                                },
                              }
                            }
                          />
                        )}
                      </CardBody>
                    </Card>
                  )}
                </Col>

                <Col md="7">
                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Photo')}</CardHeader>
                    <CardBody>
                      {error !== null && (
                        <p className="text-danger">{error}</p>
                      )}
                      <div>
                        <div className="popup-gallery hstack gap-2">
                          {data !== null && data.image_url !== null && (
                            <div className="img-fluid">
                              <img
                                src={data.image_url !== '' && data.image_url !== null ? data.image_url : `/api/inventory/thumbnail/${data.id}`}
                                alt="Item"
                                style={{
                                  cursor: 'pointer', width: '100%', maxWidth: '200px', maxHeight: '200px',
                                }}
                                onClick={() => { setIsGallery(true); }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>

                  <Card>
                    <CardHeader className="text-uppercase bg-transparent border-bottom">{t('Stock')}</CardHeader>
                    <CardBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {data !== null && (
                        <BaseGrid
                          url="/api/warehouse/location/stock"
                          filters={`pli.stock_id=${data.stock_id}`}
                          hasSearch
                          className="table table-striped table-bordered table-sm fs-5"
                          config={
                            {
                              columns: {
                                zone: {
                                  label: 'Zone',
                                  sort: true,
                                  format: (y, x) => x.location.zone,
                                  class: 'fs-6',
                                },
                                location: {
                                  label: 'Location',
                                  sort: true,
                                  html: true,
                                  format: (x) => (`${x.label}${x.full === 1 ? ` <sup><strong class="text-danger">${t('Full')}</strong></sup>` : ''}`),
                                  class: 'fs-6',
                                },
                                type: {
                                  label: 'Type',
                                  format: (f, x) => x.location.type,
                                  sort: true,
                                  class: 'fs-6',
                                },
                                qty: {
                                  label: 'Qty',
                                  sort: true,
                                  class: 'fs-6',
                                },
                                lot: {
                                  label: 'Lot',
                                  class: 'fs-6',
                                },
                                serial: {
                                  label: 'Serial',
                                  class: 'fs-6',
                                },
                              },
                              pagination: {
                                sort: 'def',
                                direction: 'asc',
                                perPage: 1000,
                              },
                            }
                          }
                        />
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Collapse>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '1'),
                  })}
                  onClick={() => {
                    toggle('1');
                  }}
                >
                  {t('Orders')}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({
                    active: (activeTab === '2'),
                  })}
                  onClick={() => {
                    toggle('2');
                  }}
                >
                  {t('Kits')}
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent
              activeTab={activeTab}
            >
              <TabPane tabId="1">
                <Row>
                  <Col sm="12">
                    <Card>
                      <CardBody>
                        {data !== null && (
                          <BaseGrid
                            url="/api/orders/byInventory"
                            filters={`items.inventory_id=${data.id}`}
                            hasSearch
                            config={
                              {
                                columns: {
                                  reference: {
                                    label: 'Order Number',
                                    sort: true,
                                    link: {
                                      to: '/orders/%id%',
                                    },
                                  },
                                  created_at: {
                                    label: 'Imported',
                                    date: {
                                      format: (date) => (moment(date).fromNow()),
                                      timezone: process.env.REACT_APP_LOCAL_TZ,
                                    },
                                    sort: true,
                                  },
                                  ship_method: {
                                    label: 'Ship Method',
                                    sort: false,
                                  },
                                  customer_note: {
                                    label: 'Customer Note',
                                    sort: false,
                                  },
                                  items: {
                                    label: 'Items',
                                    sort: false,
                                    format: (x) => {
                                      if (x !== undefined) {
                                        return Math.round(x.reduce((sum, item) => sum
                                          + item.qty, 0));
                                      }

                                      return 0;
                                    },
                                  },
                                  picking: {
                                    label: 'Picking',
                                    html: true,
                                    format: (x, ord) => {
                                      const hasPickedItems = ord.items
                                        .some((item) => item.pickroute_items
                                          .filter((z) => z.void === 0).length > 0);

                                      if (hasPickedItems) {
                                        return '<span class="mdi mdi-checkbox-marked-outline text-success fs-3"></span>';
                                      }

                                      return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3"></span>';
                                    },
                                  },
                                  packed: {
                                    label: t('Packed'),
                                    sort: false,
                                    html: true,
                                    format: (x, ord) => {
                                      const unshipped = ord.items.map(
                                        (y) => y.qty_unshipped,
                                      ).reduce((partialSum, a) => partialSum + a, 0);

                                      const itemsCount = ord.items.map(
                                        (y) => y.qty,
                                      ).reduce((partialSum, a) => partialSum + a, 0);

                                      if (unshipped > 0) {
                                        if (unshipped < itemsCount) {
                                          return '<span class="mdi mdi-checkbox-intermediate text-warning fs-3" />';
                                        }

                                        return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3" />';
                                      }

                                      return '<span class="mdi mdi-checkbox-marked-outline text-success fs-3" />';
                                    },
                                  },
                                  shipped: {
                                    label: 'Shipped',
                                    sort: false,
                                    html: true,
                                    format: (x) => {
                                      if (x === 1) {
                                        return '<span class="mdi mdi-checkbox-marked-outline text-success fs-3" />';
                                      }

                                      return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3" />';
                                    },
                                  },
                                  void: {
                                    label: 'Voided',
                                    sort: false,
                                    html: true,
                                    format: (x) => {
                                      if (x === 1) {
                                        return '<span class="mdi mdi-checkbox-marked-outline text-danger fs-3" />';
                                      }

                                      return '<span class="mdi mdi-checkbox-blank-outline text-default fs-3" />';
                                    },
                                  },
                                },
                                pagination: {
                                  sort: 'id',
                                  direction: 'desc',
                                  perPage: 30,
                                },
                              }
                            }
                          />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="2">
                <Row>
                  <Col sm="12">
                    <Card>
                      <CardBody>
                        {data !== null && (
                          <BaseGrid
                            url="/api/inventory/kit/"
                            filters={`kit_item.stock_id=${data.stock_id}`}
                            shouldUpdate={signal}
                            hasSearch
                            config={
                              {
                                columns: {
                                  thumb: {
                                    label: '',
                                    image: {
                                      src: (item) => (`/api/inventory/kit/thumbnail/${item.id}`),
                                      class: 'rounded',
                                      style: { maxHeight: '5rem', maxWidth: '5rem' },
                                    },
                                    translate: false,
                                  },
                                  stock_id: {
                                    label: props.t('Stock ID'),
                                    sort: true,
                                    link: {
                                      to: '/kits/%id%',
                                    },
                                  },
                                  sku: {
                                    label: props.t('SKU'),
                                    sort: true,
                                  },
                                  items: {
                                    label: props.t('Items'),
                                    sort: true,
                                    format: (value) => (value.map((x) => x.inventory && x.inventory.part_number).join(', ')),
                                  },
                                  qty: {
                                    label: props.t('Shelf Qty'),
                                    sort: true,
                                  },
                                  actions: {
                                    label: 'Actions',
                                    actions: [
                                      {
                                        key: 'edit_kit',
                                        icon: 'mdi mdi-pencil',
                                        class: 'btn btn-sm btn-soft-warning text-dark',
                                        alt: 'Edit Kit',
                                        click: editKit,
                                      },
                                      {
                                        key: 'remove_kit',
                                        icon: 'mdi mdi-close-thick',
                                        class: 'btn btn-sm btn-soft-danger text-dark',
                                        alt: 'Delete Kit',
                                        click: deleteKit,
                                      },
                                    ],
                                  },
                                },
                                pagination: {
                                  sort: 'id',
                                  direction: 'asc',
                                  perPage: 30,
                                },
                              }
                            }
                          />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>

            <KitFormModal
              shown={kitModal !== false}
              kit={kitModal !== false ? kitModal : { stock_id: '', items: [] }}
              onSuccess={() => {
                setSignal(signal + 1);
                setKitModal(false);
              }}
            />
          </Col>
        </Row>
      </div>

      {isGallery ? (
        <Lightbox
          mainSrc={data.image_url !== '' && data.image_url !== null ? data.image_url : `/api/inventory/thumbnail/${data.id}`}
          enableZoom={false}
          onCloseRequest={() => setIsGallery(false)}
          imageCaption={data.part_number}
        />
      ) : null}
    </div>
  );
}

ViewItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(ViewItem));
